// extracted by mini-css-extract-plugin
export default {"img_container":"ImgLoader_img_container__vnHDx","skeleton":"ImgLoader_skeleton__KRN3y","shimmer":"ImgLoader_shimmer__93Qvd"};